module.exports = __webpack_public_path__ + "static/media/13finanzas.02ab512.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/13finanzas.mp4
// module id = 721
// module chunks = 1